import { gql } from '@apollo/client';
const UPDATE_PRODUCT_CERTIFICATE = gql `
  mutation UpdateProductCertificate(
    $productCertificateId: ID!
    $name: String!
    $description: String
    $thumbnail: String
  ) {
    updateProductCertificate(
      productCertificateId: $productCertificateId
      name: $name
      description: $description
      thumbnail: $thumbnail
    ) {
      productCertificate {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default UPDATE_PRODUCT_CERTIFICATE;
